import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import { openEmailConfirmationModal } from "@js/apps/auth/components/sign-up-confirmation-content";
import { useUser } from "@js/apps/common/hooks";
import { useEffectRef } from "@js/hooks/use-effect-ref";

type UseEmailConfirmationModalProps = {
  pathToShowConfirmationModal?: RegExp;
  pathsToHideConfirmationModal?: Array<RegExp>;
  callback?: () => void;
};

export const useEmailConfirmationModal = ({
  pathToShowConfirmationModal,
  pathsToHideConfirmationModal,
  callback,
}: UseEmailConfirmationModalProps) => {
  const user = useUser();
  const wasShownRef = useRef(false);
  const { pathname } = useLocation();
  const isSessionImpersonated = !!user?.is_impersonated_session;
  const isVerifiedUser = !!user?.is_verified;

  const callbackRef = useEffectRef(callback);
  useEffect(() => {
    if (isVerifiedUser || wasShownRef.current || isSessionImpersonated) return;

    if (
      pathToShowConfirmationModal &&
      !pathToShowConfirmationModal.test(pathname)
    ) {
      return;
    }

    const matchPath = (path: RegExp) => path.test(pathname);
    if (
      pathsToHideConfirmationModal &&
      pathsToHideConfirmationModal.some(matchPath)
    ) {
      return;
    }

    wasShownRef.current = true;
    openEmailConfirmationModal(() => callbackRef.current?.());
  }, [
    isVerifiedUser,
    pathname,
    wasShownRef,
    pathToShowConfirmationModal,
    pathsToHideConfirmationModal,
    isSessionImpersonated,
    callbackRef,
  ]);
};
